module.exports = __webpack_public_path__ + "img/banner2.147c2332.png";